import { CLEAR_EDITED_BASKET, UNDO_BASKET_EDITS, UNDO_MEAL_OPTIONS } from 'actions/basketEdits';
import { ADD_BASKET_REQUEST, UPDATE_BASKET_REQUEST } from 'actions/baskets';
import { SHOW_CUSTOMIZE_IT_CARD, CLOSE_CUSTOMIZE_IT_CARD } from 'actions/customizeIt';
import {
  UNDO_MEAL_OPTIONS_V3,
  UNDO_BASKET_EDITS_V3,
  CLEAR_EDITED_BASKET_V3,
} from 'lib/constants/v3Actions';

const initialState = {};

export default (state = initialState, action) => {
  const { mealId, type, customizeItLabel } = action;

  switch (type) {
    case SHOW_CUSTOMIZE_IT_CARD:
      return { [mealId]: { exists: true, customizeItLabel } };
    case UNDO_MEAL_OPTIONS:
    case UNDO_MEAL_OPTIONS_V3:
    case UNDO_BASKET_EDITS:
    case UNDO_BASKET_EDITS_V3:
    case ADD_BASKET_REQUEST:
    case UPDATE_BASKET_REQUEST:
    case CLEAR_EDITED_BASKET:
    case CLEAR_EDITED_BASKET_V3:
    case CLOSE_CUSTOMIZE_IT_CARD:
      return initialState;
    default:
      return state;
  }
};

export const selectCustomizeItForMealId = (state, mealId) => state[mealId] || false;
